module.exports = __webpack_public_path__ + "img/vswiper6.ceac6361.png";